/**
 * composeBrandedTitle — builds the row / intro headline.
 *
 * Shape: `${player} ${clip.title}` (e.g., "donk ACE on Overpass"). We use
 * the raw `clip.title` straight from partner-api now instead of mapping
 * tag labels into noun phrases — the engine-emitted title already
 * carries the kill / clutch / map context in canonical wording, and the
 * tag-phrase composer was duplicating that work with a less accurate
 * vocabulary.
 *
 * Player name is preserved as a prefix because the engine title does
 * NOT lead with the player ("ACE on Overpass" vs. our needed "donk ACE
 * on Overpass"). When player resolution fails we fall back to just the
 * raw clip title.
 */
import type { PlaylistClip } from "../../@types";
import { getPlayerName } from "./metadataHelpers";

export const composeBrandedTitle = (clip: PlaylistClip | null): string => {
  if (!clip) return "";
  const player = getPlayerName(clip);
  const raw = clip.title?.trim() ?? "";
  if (!player) return raw || "Featured highlight";
  if (!raw) return `${player}'s highlight`;
  return `${player} ${raw}`;
};
